import React from 'react'
import PropTypes from 'prop-types'

import { EmailInput } from 'components/EmailInput'

const EmailField = ({ onChange, email }) => (
  <div className="field">
    <EmailInput placeholder="Work email address" value={email} onChange={onChange} />
  </div>
)

EmailField.propTypes = {
  onChange: PropTypes.func,
  email: PropTypes.string,
}

export default EmailField



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/SignUpFormV2/EmailField/index.js